import { render, staticRenderFns } from "./me-edit-password.vue?vue&type=template&id=5987490c&scoped=true"
import script from "./me-edit-password.vue?vue&type=script&lang=js"
export * from "./me-edit-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987490c",
  null
  
)

export default component.exports